import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  text-decoration: underline;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import styled from "styled-components";
import Text from "./Text";
var Underlined = styled(Text).attrs(function(param) {
    var _as = param.as, as = _as === void 0 ? "span" : _as;
    return {
        as: as
    };
}).withConfig({
    componentId: "sc-7ab02915-0"
})(_templateObject());
export default Underlined;
